var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3801 17.1876L14.7432 12.5508C15.7977 10.9854 16.3179 9.02958 16.0394 6.94553C15.5645 3.40071 12.6592 0.515963 9.11089 0.0667305C3.8353 -0.600824 -0.600855 3.83533 0.0667378 9.11092C0.516087 12.6608 3.40122 15.5684 6.94642 16.041C9.03047 16.3194 10.9867 15.7994 12.5517 14.7448L17.1885 19.3816C17.7936 19.9867 18.7748 19.9867 19.3798 19.3816C19.9844 18.7758 19.9844 17.7919 19.3801 17.1876ZM3.06405 8.05728C3.06405 5.32322 5.28833 3.09894 8.02238 3.09894C10.7564 3.09894 12.9807 5.32322 12.9807 8.05728C12.9807 10.7913 10.7564 13.0156 8.02238 13.0156C5.28833 13.0156 3.06405 10.7921 3.06405 8.05728Z",
    fill: "url(#paint0_linear_12552_18890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12552_18890",
    x1: 1.2232e-8,
    y1: 10.5789,
    x2: 19.8333,
    y2: 10.5789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGradient);
export default __webpack_public_path__ + "static/media/search_gradient.edbc8fb5196841ce316ba43bcfdfd00c.svg";
export { ForwardRef as ReactComponent };